var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { BodyText, MetaText, HeadingSmall, HeadingXSmall, InlineLink, ListGrid, Modal, Preamble, PrimaryButton, } from '@hm-group/fabric-components';
import cn from 'classnames';
import Portal from "../../helpers/Portal";
import "./NotifyIfBack.css";
var styles = { "modalContent": "e2328b", "nibModalButton": "e17c30", "innerHeading": "e7f24b", "infoText": "d44410", "infoTextTop": "b19068", "boldText": "fb4990", "emailWrapper": "ddaed6", "emailLabel": "d21875", "emailAddress": "b96bb6", "privacyLink": "d0bef5", "privacyDescription": "ee1a72", "successTitle": "fdb1ed", "errorTitle": "ba2299", "successInfo": "c6db49", "errorInfo": "eca2ca", "sizePickerWrapper": "b21fb3", "selectSizeTitle": "bd22bf", "sizeList": "c18893", "sizeInputItem": "ddaa3b" };
const NotifyIfBack = ({ oosItems, productId, labels, isSetNotifyIfBackLoading, isSetNotifyIfBackSuccessful, onSubmitNotifyIfBack, isShowNotifyIfBackModal, setIsShowNotifyIfBackModal, setIsSetNotifyIfBackSuccessful, onClickSigninNotifyIfBack, userData, defaultSelectedSize, }) => {
    const [selectedVariant, setSelectedVariant] = useState('');
    let heading;
    let info;
    let text;
    let boldText;
    let button;
    let onClickButton;
    let disabledButton = false;
    useEffect(() => {
        setSelectedVariant((oosItems === null || oosItems === void 0 ? void 0 : oosItems.length) === 1 ? oosItems[0].sizeCode : defaultSelectedSize || '');
        if (!isShowNotifyIfBackModal && isSetNotifyIfBackSuccessful !== null) {
            setTimeout(() => setIsSetNotifyIfBackSuccessful(null), 500);
        }
    }, [isShowNotifyIfBackModal]);
    const handleCloseModal = () => {
        setIsShowNotifyIfBackModal(false);
    };
    const handleSubmitNib = () => __awaiter(void 0, void 0, void 0, function* () {
        onSubmitNotifyIfBack({
            bpid: userData === null || userData === void 0 ? void 0 : userData.bpid,
            email: userData === null || userData === void 0 ? void 0 : userData.email,
            variant: `${productId}${selectedVariant}`,
        });
    });
    if (userData === null || userData === void 0 ? void 0 : userData.email) {
        switch (isSetNotifyIfBackSuccessful) {
            case false:
                heading = labels === null || labels === void 0 ? void 0 : labels.labelErrorHeading;
                info = labels === null || labels === void 0 ? void 0 : labels.labelErrorInfo;
                button = labels === null || labels === void 0 ? void 0 : labels.labelErrorButton;
                onClickButton = handleSubmitNib;
                break;
            case true:
                heading = labels === null || labels === void 0 ? void 0 : labels.labelSuccessHeading;
                button = labels === null || labels === void 0 ? void 0 : labels.labelSuccessButton;
                onClickButton = handleCloseModal;
                break;
            default:
                heading = labels === null || labels === void 0 ? void 0 : labels.labelSelectHeading;
                info = labels === null || labels === void 0 ? void 0 : labels.labelSelectInfo;
                boldText = labels === null || labels === void 0 ? void 0 : labels.labelSelectEmail;
                text = userData === null || userData === void 0 ? void 0 : userData.email;
                button = labels === null || labels === void 0 ? void 0 : labels.labelNotifyMe;
                onClickButton = handleSubmitNib;
                if (selectedVariant === '') {
                    disabledButton = true;
                }
        }
    }
    else {
        heading = labels === null || labels === void 0 ? void 0 : labels.labelLoginInfo;
        info = labels === null || labels === void 0 ? void 0 : labels.labelLoginText;
        button = labels === null || labels === void 0 ? void 0 : labels.labelLoginButton;
        onClickButton = onClickSigninNotifyIfBack;
    }
    const handleSizeClick = (sizeCode) => {
        setSelectedVariant(sizeCode);
    };
    const handleSizePressEnter = (e, sizeCode) => {
        if (e.keyCode === 13) {
            setSelectedVariant(sizeCode);
        }
    };
    const gridColItems = oosItems
        ? (oosItems === null || oosItems === void 0 ? void 0 : oosItems.length) === 1
            ? 1
            : (oosItems === null || oosItems === void 0 ? void 0 : oosItems.length) === 2 || (oosItems === null || oosItems === void 0 ? void 0 : oosItems.length) <= 4
                ? 2
                : (oosItems === null || oosItems === void 0 ? void 0 : oosItems.length) <= 6
                    ? 3
                    : (oosItems === null || oosItems === void 0 ? void 0 : oosItems.length) <= 8
                        ? 4
                        : 5
        : 1;
    return (React.createElement(Portal, null,
        React.createElement(Modal, { heading: (labels === null || labels === void 0 ? void 0 : labels.labelNotifyMe) || '', isOpen: isShowNotifyIfBackModal, onClose: handleCloseModal, closeLabel: (labels === null || labels === void 0 ? void 0 : labels.labelClose) || '', actions: React.createElement(PrimaryButton, { type: "button", onClick: onClickButton, className: cn(styles.nibModalButton), isDisabled: disabledButton || isSetNotifyIfBackLoading }, button || ''), content: React.createElement("div", { className: styles.modalContent },
                isSetNotifyIfBackSuccessful ? (React.createElement(React.Fragment, null,
                    React.createElement(BodyText, { Tag: "h2", className: cn(styles.successTitle) }, heading),
                    React.createElement(HeadingXSmall, { Tag: "h3", className: cn(styles.successInfo) }, userData === null || userData === void 0 ? void 0 : userData.email))) : (React.createElement(React.Fragment, null,
                    heading && (React.createElement(HeadingSmall, { className: cn([
                            styles.innerHeading,
                            { [styles.errorTitle]: isSetNotifyIfBackSuccessful === false },
                        ]) }, heading)),
                    info && (React.createElement(BodyText, { className: cn([
                            styles.infoText,
                            {
                                [styles.infoTextTop]: !heading,
                                [styles.errorInfo]: isSetNotifyIfBackSuccessful === false,
                            },
                        ]) }, info)))),
                (userData === null || userData === void 0 ? void 0 : userData.email) && isSetNotifyIfBackSuccessful === null && (React.createElement("div", { className: styles.sizePickerWrapper },
                    React.createElement(Preamble, { className: styles.selectSizeTitle }, labels === null || labels === void 0 ? void 0 : labels.labelSelectSize),
                    React.createElement(ListGrid, { className: styles.sizeList, numberOfColumns: {
                            xsmall: gridColItems,
                            small: gridColItems,
                            medium: gridColItems,
                            large: gridColItems,
                            xlarge: gridColItems,
                        } }, oosItems &&
                        oosItems.map(({ sizeName, sizeCode }) => (React.createElement(React.Fragment, { key: sizeCode },
                            React.createElement("input", { className: styles.sizeInputItem, tabIndex: 0, type: "radio", id: sizeCode, name: "radioFruit", value: sizeCode || '', checked: selectedVariant === sizeCode, onChange: () => {
                                    handleSizeClick(sizeCode);
                                }, onKeyDown: (e) => {
                                    handleSizePressEnter(e, sizeCode);
                                } }),
                            React.createElement("label", { htmlFor: sizeCode }, sizeName === null || sizeName === void 0 ? void 0 : sizeName.toUpperCase()))))))),
                (userData === null || userData === void 0 ? void 0 : userData.email) && boldText && (React.createElement("div", { className: cn(styles.emailWrapper) },
                    React.createElement(BodyText, { className: styles.emailLabel, isMarginless: true }, boldText),
                    React.createElement(BodyText, { className: styles.emailAddress, isMarginless: true }, text))),
                (userData === null || userData === void 0 ? void 0 : userData.email) && isSetNotifyIfBackSuccessful === null && (React.createElement(React.Fragment, null,
                    React.createElement(MetaText, { className: cn(styles.privacyDescription) },
                        (labels === null || labels === void 0 ? void 0 : labels.labelWarningEmail) || '',
                        (React.createElement(InlineLink, { token: "meta", className: styles.privacyLink, href: "customer-service/legal-and-privacy/privacy-link.html" }, `${labels === null || labels === void 0 ? void 0 : labels.labelWarningPrivacy}.`)))))) })));
};
export default NotifyIfBack;
//# sourceMappingURL=NotifyIfBack.js.map